var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 599.94 687.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:none;}.cls-2,.cls-3{stroke:#4a5eff;}.cls-2,.cls-4,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-3{fill:rgba(74,94,255,.2);stroke-linecap:round;stroke-linejoin:round;}.cls-4{stroke:url(#linear-gradient-6);}.cls-4,.cls-5,.cls-7{fill:#7da2fe;}.cls-5{stroke:url(#linear-gradient-5);}.cls-6{fill:rgba(255,255,255,.2);stroke:#fff;}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient);}.cls-7{stroke:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-4);}.cls-11{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 338.79,
    y1: 372.45,
    x2: 371.81,
    y2: 372.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 333.2,
    y1: 420.39,
    x2: 348.12,
    y2: 420.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 362.48,
    y1: 420.39,
    x2: 377.4,
    y2: 420.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 348.38,
    y1: 421,
    x2: 362.22,
    y2: 421,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 21.05,
    y1: 621.63,
    x2: 54.36,
    y2: 621.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 130.46,
    y1: 600.48,
    x2: 163.77,
    y2: 600.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 239.86,
    y1: 572.27,
    x2: 273.17,
    y2: 572.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 355.3,
    y1: 660.2,
    x2: 355.3,
    y2: 424.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e25300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad336"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M370.08,351.44l-14.78-24.47-14.78,24.47s-4.01,33.01,.17,48.42c3.16,11.63,9.04,18.08,9.04,18.08h11.12s5.89-6.44,9.04-18.08c4.19-15.42,.17-48.42,.17-48.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.12,418.63l-2.67,4-1.58,12.41c-.15,1.18-1.75,1.44-2.27,.36l-8.06-16.86c-.51-1.06-.43-2.31,.2-3.31l6.72-10.54c2.8,7.72,6.47,12.5,7.66,13.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M370.14,404.7l6.72,10.54c.63,.99,.71,2.24,.2,3.31l-8.06,16.86c-.51,1.08-2.12,.82-2.27-.36l-1.58-12.41-2.67-4c1.19-1.43,4.86-6.21,7.66-13.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "360.86 419.37 355.3 419.37 349.74 419.37 348.38 421.47 349.09 422.63 355.3 422.63 361.51 422.63 362.22 421.47 360.86 419.37"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.95,659.55h-45.62c-2.19,0-4.03-1.75-4.03-3.94v-.04c0-11.78,9.54-21.32,21.32-21.32,.14,0,.29,0,.43,0,2.27-15.29,13.35-27.7,27.91-31.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414.2,659.55h174.64c5.69,0,10.41-4.5,10.58-10.19,0-.13,0-.26,0-.39,.42-21.34-16.62-39.37-37.95-40.07-7.06-.23-13.71,1.39-19.52,4.43-9.15-22.93-31.56-39.13-57.75-39.13-17.89,0-34.02,7.56-45.35,19.66-2.88,3.06-5.44,6.42-7.65,10.01h0c-4.7-1.98-9.87-3.09-15.3-3.09-.57,0-1.14,0-1.72,.03"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 355.3,
    cy: 360.49,
    r: 9.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M304.93,659.55h-123.1c-33.36,0-60.4-27.04-60.4-60.4s27.04-60.4,60.4-60.4c18.73,0,35.48,8.53,46.56,21.92,4.4-1.24,9.04-1.92,13.84-1.92,20.85,0,38.75,12.66,46.41,30.72,2.86-1.65,6.19-2.59,9.73-2.59,10.8,0,19.57,8.76,19.57,19.57,0,3.55-.95,6.88-2.6,9.75,3.77,1.93,6.93,4.85,9.12,8.44,2.18-1.05,4.62-1.64,7.21-1.64,9.22,0,16.69,7.48,16.69,16.69s-7.48,16.69-16.69,16.69c-3.96,0-7.59-1.37-10.44-3.67-4.15,4.22-9.93,6.84-16.32,6.84"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 204.34,
    cy: 590.24,
    r: 23.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 281.12,
    cy: 641.44,
    r: 16.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.4,600.9c0,9.31-7.54,16.85-16.85,16.85-3.46,0-6.68-1.04-9.35-2.83v-28.06c2.67-1.78,5.89-2.83,9.35-2.83,6.79,0,12.65,4.03,15.32,9.82,.98,2.14,1.53,4.52,1.53,7.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 171.96,
    cy: 630.57,
    r: 8.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 101.49,
    cy: 574.2,
    r: 8.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 557.71,
    cy: 578.66,
    r: 14.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M560.61,641.95c0,6.95-2.93,13.2-7.6,17.6h-33.21c-4.68-4.4-7.6-10.65-7.6-17.6,0-10.64,6.86-19.67,16.4-22.9,2.45-.84,5.08-1.29,7.81-1.29,13.36,0,24.2,10.83,24.2,24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.93,659.55c12.13-6.98,20.3-20.07,20.3-35.07,0-22.33-18.1-40.44-40.44-40.44s-40.44,18.1-40.44,40.44c0,15,8.16,28.09,20.3,35.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M536.32,647.28c0,4.21-.47,8.32-1.36,12.27h-108.23c-.89-3.94-1.36-8.06-1.36-12.27,0-6.39,1.08-12.54,3.07-18.25,7.55-21.68,28.16-37.23,52.41-37.23,20.33,0,38.1,10.93,47.76,27.24,4.91,8.27,7.72,17.93,7.72,28.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "37.71 584.2 21.92 611.55 32.24 611.55 32.24 659.55 43.17 659.55 43.17 611.55 53.49 611.55 37.71 584.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "147.11 541.91 131.33 569.25 141.65 569.25 141.65 659.55 152.58 659.55 152.58 569.25 162.9 569.25 147.11 541.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "256.52 485.48 240.73 512.82 251.05 512.82 251.05 659.55 261.98 659.55 261.98 512.82 272.31 512.82 256.52 485.48"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "423.45 362.83 423.45 186.25 423.45 56.76 442.79 95.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "404.95 74.84 404.95 233.34 404.95 602.33 404.95 624.3 404.95 659.55 404.95 678.15 .5 678.15 .5 687.4 414.2 687.4 414.2 659.55 414.2 623.14 414.2 614.92 414.2 600.82 414.2 586.86 414.2 233.34 414.2 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "365.9 660.2 344.7 660.2 349.22 424.48 361.38 424.48 365.9 660.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M414.2,659.55v-36.42c5.43,.37,10.38,2.53,14.23,5.9,5.09,4.43,8.31,10.96,8.31,18.25,0,4.48-1.22,8.67-3.35,12.27h-19.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M391.67,659.55c-2.13-3.6-3.35-7.79-3.35-12.27,0-10.72,6.97-19.81,16.62-22.99v35.26h-13.28Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket1);
export default __webpack_public_path__ + "static/media/rocket-1.c1712392444172301b0fe1ca05d523e4.svg";
export { ForwardRef as ReactComponent };